import React from 'react';
import './Pages/PagesCss/Footer.css';
import logo from '../components/assets/flogo.png';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-main">
      <div className="footer-wrapper">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-section">
              <div className="brand-logo">
                <img src={logo} alt="AfterTaxPay Logo" className="logo-img" />
                <div className="brand-text">
                  <h2 className="brand-name">AfterTaxPay</h2>
                  <span className="brand-tagline">Smart Financial Tools</span>
                </div>
              </div>
              <p className="brand-description">
                D-Tech Studios develops and maintains this platform, providing reliable payroll, tax, and net pay calculators. Employees and employers can manage salaries easily, with precise calculations delivered instantly.
              </p>
              <div className="social-section">
                <h4 className="social-title">Follow Us</h4>
                <div className="social-icons">
                  <a 
  href="https://www.facebook.com/people/D-Tech-Studios/61556107977536" 
  className="social-link" 
  aria-label="Facebook" 
  target="_blank" 
  rel="noopener noreferrer"
>
 <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24h11.495v-9.294H9.691V11.01h3.13V8.41c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.31h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z" />
    </svg>
  <span className="social-tooltip">Facebook</span>
</a>
                  <a href="https://x.com/D_TechStudios"
                   className="social-link" 
  aria-label="Twitter" 
  target="_blank" 
  rel="noopener noreferrer"
>
                    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.59-6.64 7.59H.47l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zM17.61 20.644h2.04L6.486 3.24H4.298L17.61 20.644z" />
    </svg>
                    <span className="social-tooltip">Twitter</span>
                  </a>
                  <a href="https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile"
                  className="social-link" 
  aria-label="LinkedIn" 
  target="_blank" 
  rel="noopener noreferrer"
>
                    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.27 2.3-2.6 4.73-2.6 5.06 0 6 3.33 6 7.66V24h-5V16.2c0-1.86-.04-4.26-2.6-4.26-2.6 0-3 2.03-3 4.12V24h-5V8z" />
    </svg>
                    <span className="social-tooltip">LinkedIn</span>
                  </a>
                  <a href="https://www.instagram.com/d_techstudios/"
                  className="social-link" 
  aria-label="Instagram" 
  target="_blank" 
  rel="noopener noreferrer"
>
                    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.343 3.608 1.318.975.975 1.256 2.242 1.318 3.608.058 1.266.07 1.646.07 4.84s-.012 3.574-.07 4.84c-.062 1.366-.343 2.633-1.318 3.608-.975.975-2.242 1.256-3.608 1.318-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.343-3.608-1.318-.975-.975-1.256-2.242-1.318-3.608C2.175 15.574 2.163 15.194 2.163 12s.012-3.574.07-4.84c.062-1.366.343-2.633 1.318-3.608.975-.975 2.242-1.256 3.608-1.318 1.266-.058 1.646-.07 4.84-.07zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
    </svg>
                    <span className="social-tooltip">Instagram</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Links Grid */}
          <div className="footer-links-grid">
            {/* Tools Column */}
            <div className="footer-col">
              <h5 className="col-title">
                <i className="fas fa-tools"></i>
                Tools
              </h5>
              <ul className="col-list">
                <li>
                  <NavLink to="/PayrollCalculatorUSA" className="col-link">
                    <i className="fas fa-calculator"></i>
                    Payroll Tax Calculator
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/PropertyTaxCalculatorUSA" className="col-link">
                    <i className="fa fa-landmark"></i>
                    Estate Tax Calculator
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/TaxReturnCalculatorUSA" className="col-link">
                    <i className="fas fa-dollar-sign"></i>
                    Tax Returns Calculator
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/RetirementTaxCalculatorUSA" className="col-link">
                    <i className="fa-solid fa-file-invoice-dollar"></i>
                    Retirement Tax Calculator
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Navigation Column */}
            <div className="footer-col">
              <h5 className="col-title">
                <i className="fas fa-compass"></i>
                Navigation
              </h5>
              <ul className="col-list">
                <li>
                  <NavLink to="/" className="col-link">
                    <i className="fas fa-home"></i>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/AboutUs" className="col-link">
                    <i className="fas fa-info-circle"></i>
                    About
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/Contact" className="col-link">
                    <i className="fas fa-envelope"></i>
                    Contact
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Legal Column */}
            <div className="footer-col">
              <h5 className="col-title">
                <i className="fas fa-balance-scale"></i>
                Legal
              </h5>
              <ul className="col-list">
                <li>
                  <NavLink to="/PrivacyPolicy" className="col-link">
                    <i className="fas fa-shield-alt"></i>
                    Privacy Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/TermsOfService" className="col-link">
                    <i className="fas fa-file-contract"></i>
                    Terms of Service
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/Disclaimer" className="col-link">
                    <i className="fas fa-exclamation-triangle"></i>
                    Disclaimer
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ContentPolicy" className="col-link">
                    <i className="fas fa-file-alt"></i>
                    Content Policy
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/CookiePolicy" className="col-link">
                    <i className="fas fa-cookie"></i>
                    Cookie Policy
                  </NavLink>
                </li>
                <li>
                  <a href="/sitemap.xml" className="col-link" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-sitemap"></i>
                    Sitemap
                  </a>
                </li>
              </ul>
            </div>

            {/* Newsletter Column */}
            <div className="footer-col">
  <h5 className="col-title">
    <i className="fas fa-globe"></i>
    Explore Our Platforms
  </h5>
  <ul className="col-list">
    <li>
      <a 
        href="https://d-techstudios.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        D-Techstudios
      </a>
    </li>
    <li>
      <a 
        href="https://cryptomux.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        Cryptomux
      </a>
    </li>
    <li>
      <a 
        href="https://noobtobull.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        NoobToBull
      </a>
    </li>
    <li>
      <a 
        href="https://creditsiq.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        CreditsIq
      </a>
    </li>
    <li>
      <a 
        href="https://aipicks.org" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        Aipicks
      </a>
    </li>
    <li>
      <a 
        href="https://font-max.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="col-link"
      >
        <i className="fas fa-external-link-alt"></i>
        Font-Max
      </a>
    </li>
  </ul>
</div>

          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="bottom-content">
            <p className="copyright">
              © {currentYear} <span className="copyright-brand">AfterTaxPay.net</span>. All rights reserved.
            </p>
            <div className="footer-badges">
              <span className="badge">
                <i className="fas fa-lock"></i>
                Secure & Private
              </span>
              <span className="badge">
                <i className="fas fa-bolt"></i>
                Fast Calculations
              </span>
              <span className="badge">
                <i className="fas fa-check-circle"></i>
                Accurate Results
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;